var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c("q-toolbar-title", { staticClass: "q-body-2" }, [
            _c("span", { staticClass: "text-grey-10" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$tc("finance", 2)) +
                  "\n            "
              )
            ]),
            _vm._v(" / "),
            _c("span", { staticClass: "text-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("overview")))
            ])
          ]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                position: "absolute",
                right: "10px"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("q-select", {
                    staticClass: "q-mr-sm",
                    attrs: {
                      placeholder: _vm.$t("finances_year"),
                      options: _vm.averageYearOptions,
                      "no-parent-field": "",
                      "hide-underline": ""
                    },
                    model: {
                      value: _vm.selectedYear,
                      callback: function($$v) {
                        _vm.selectedYear = $$v
                      },
                      expression: "selectedYear"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("q-select", {
                    staticClass: "q-mr-sm",
                    attrs: {
                      placeholder: _vm.$t("finances_time_span"),
                      options: _vm.timeSpanOptions,
                      "no-parent-field": "",
                      "hide-underline": ""
                    },
                    model: {
                      value: _vm.selectedTimeSpan,
                      callback: function($$v) {
                        _vm.selectedTimeSpan = $$v
                      },
                      expression: "selectedTimeSpan"
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _c(
            "div",
            {
              staticClass: "full-width",
              staticStyle: {
                display: "flex",
                "flex-flow": "row wrap",
                "justify-content": "space-evenly",
                "align-content": "space-between"
              }
            },
            _vm._l(_vm.dataArray, function(data, index) {
              return _c("selected-time-card", {
                key: index,
                attrs: { time: data.time, year: data.year, index: index },
                on: { cardClick: _vm.handleCardClick }
              })
            })
          ),
          _c("finances-display", {
            attrs: {
              revenue: _vm.currentRevenue,
              expense: _vm.currentExpense,
              time: _vm.currentTimeSpan
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }